const uniqueItemId = ({ itemId, options }: WebOrder.State.BasketItem) =>
  JSON.stringify({
    [itemId]: options,
  });

export const basketUtils = {
  uniqueItemId,
};
